var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-07-11
 * @brief EHP 진단점검 Report - List 개발
 *
 ********************************************************************/
import React, { useState, useEffect, useCallback, useRef } from "react";
//
import axios from 'axios';
import { useAsync } from "react-async";
// recoli & state
import { useRecoilValue, useRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { loadingBoxState } from "../../../recoil/menuState";
import { langState } from "../../../recoil/langState";
//
import { useTrans } from "../../../utils/langs/useTrans";
//utils
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as FILEUTILS from "../../../utils/file/fileUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
//datepicker
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
//datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
//datepocker 언어
import { ko, enUS, zhCN, } from "date-fns/esm/locale";
//압축 다운로드
import JSZip from "jszip";
import { useNavigate } from "react-router-dom";
import EhpPagination from "../../common/pagination/EhpPagination";
//var zip = require('jszip')();
/**
 * @brief EHP 진단점검 Report List 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ItemCheckHistory(props) {
    //trans
    const t = useTrans();
    //recoil
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const setParentPopWin = props.setPopWin;
    const setParentCurHistoryData = props.setCurHistoryData;
    const setParentCurHistoryInfo = props.setCurHistoryInfo;
    const setResultOpen = props.setResultOpen;
    //tab
    const [tabItem, setTabItem] = useState([]);
    const [curTab, setCurTab] = useState(null);
    const [curPos, setCurPos] = useState(0);
    const tabRef = useRef(null);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10, "listReload": false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    //세부사업장
    const [subZoneItem, setSubZoneItem] = useState([]);
    const [subZoneSel, setSubZoneSel] = useState("");
    const [subZone, setSubZone] = useState("");
    //사이트
    const [roomItem, setRoomItem] = useState([]);
    const [roomSel, setRoomSel] = useState("");
    const [room, setRoom] = useState("");
    //spg
    const [spgItem, setSpgItem] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const mintStartDate = dayjs(endDate).set("year", dayjs(endDate).year() - 1).toDate(); // 종료일 기준 1년
    const maxEndDate = dayjs(startDate).set("year", dayjs(startDate).year() + 1).toDate(); // 시작일 기준 1년
    const [spg, setSpg] = useState([]);
    const [searchFilterList, setSearchFilterList] = useState([]);
    const dateTermList = [
        { "id": 0, "dtDisp": "직접입력", "dtVal": 0 },
        { "id": 1, "dtDisp": t("LABEL.T1개월", ["1"]), "dtVal": 30 },
        { "id": 2, "dtDisp": t("LABEL.T1개월", ["3"]), "dtVal": 90 },
        { "id": 3, "dtDisp": t("LABEL.T1개월", ["6"]), "dtVal": 180 },
        { "id": 4, "dtDisp": t("LABEL.T1년", ["1"]), "dtVal": 365 },
    ];
    const [dateTerm, setDateTerm] = useState(dateTermList[0]);
    ///
    const [searchCount, setSearchCount] = useState({
        "startDate": null,
        "endDate": null,
    });
    const searchFieldList = [
        //{"id":0, "sfDisp":"전체", "sfVal":""},
        { "id": 1, "sfDisp": t("FIELD.모델명"), "sfVal": "itemName" },
        { "id": 2, "sfDisp": t("FIELD.시리얼번호"), "sfVal": "serialNo" },
        // { "id": 3, "sfDisp": t("FIELD.Panel명"), "sfVal": "panelName" },
    ];
    const [searchField, setSearchField] = useState(searchFieldList[0]);
    const [searchText, setSearchText] = useState("");
    const [searchData, setSearchData] = useState({
        "searchField": null,
        "searchText": null,
    });
    const [checkItem, setCheckItem] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setIsMobile(true);
                if (pageInfo.totalElements <= 0) {
                    setIsMobile(false);
                }
            }
            else {
                setIsMobile(false);
            }
        }
    }, [pageInfo]);
    // tab APi
    const { data: tab, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: "/api/v2/product/zone/company",
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (tab) {
            // error page 이동
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, tab);
            if (ERR_URL.length > 0) {
                setRecoilIsLoadingBox(false);
                navigate(ERR_URL);
            }
            if (tab.codeNum == 200) {
                setTabItem(tab.body);
                setCurTab(tab.body[0]);
            }
        }
    }, [tab]);
    useEffect(() => {
        if (curTab) {
            let today = new Date();
            const startdate = new Date(new Date().setDate(today.getDate() - 365));
            onClickTab(curTab);
            setSubZoneSel("");
            setSubZone("");
            setRoomSel("");
            setRoom("");
            setSearchCount({
                "startDate": startdate,
                "endDate": today,
            });
        }
    }, [curTab]);
    // tab 이동 액션
    function onClickTab(item) {
        setCurTab(item);
        handleCurPage(0);
        setParentCurHistoryData(null);
        setParentCurHistoryInfo(null);
        setSubZoneSel("");
        setSubZone("");
        setRoomSel("");
        setRoom("");
        resetSearchParams();
    }
    // 이전&다음 버튼 이벤트
    function next(idx) {
        setCurPos(idx + 1);
    }
    function prev(idx) {
        setCurPos(idx - 1);
    }
    //subZone 선택 및 Room API
    function subZoneSle(e, zoneId) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/product/company/zone/${zoneId}`,
                /*     "appQuery": {
                         "zoneId ": curTab.zoneId,
                     },  */
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSubZoneItem(data.body);
                }
                else {
                    alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    // 세부사업장 셀텍트
    function onClickSubZoneSelect(subZoneId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/product/company/zone/subzone/${subZoneId}`,
                userToken: userInfo.loginInfo.token,
            });
            if (data.codeNum == 200) {
                setRoomItem(data.body);
                setSubZoneSel(subZoneId);
            }
            else {
                alert(data.errorList.map((err) => (err.msg)));
            }
        });
    }
    const [dateSel, setDateSel] = useState(null);
    // 날짜 기간조회
    function handleDayPop(days) {
        if (days.dtVal > 0) {
            const today = new Date();
            const newDay = new Date();
            //  clog(daySelected);
            setStartDate(newDay.setDate(today.getDate() - days.dtVal));
            setEndDate(today);
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
        setDateSel(days.id);
    }
    const { data: device } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: "/api/v2/product/company/zone/subzone/room/spgs",
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (device) {
            if (device.codeNum == CONST.API_200) {
                setSpgItem([
                    { fname: t("LABEL.전체"), checked: true, val: "all" },
                    { fname: device.body[0].spgName, checked: false, val: device.body[0].spgName },
                    { fname: device.body[1].spgName, checked: false, val: device.body[1].spgName },
                    { fname: device.body[2].spgName, checked: false, val: device.body[2].spgName },
                    { fname: device.body[3].spgName, checked: false, val: device.body[3].spgName },
                    { fname: device.body[4].spgName, checked: false, val: device.body[4].spgName },
                    { fname: device.body[5].spgName, checked: false, val: device.body[5].spgName },
                ]);
            }
            else {
                alert(device.errorList.map((err) => (err.msg)));
            }
        }
    }, [device]);
    const [filterList, setFilterList] = useState([
        { dname: t("LABEL.전체"), checked: true, val: "all" },
        { dname: "Basic", checked: false, val: "BASIC" },
        { dname: "Premium", checked: false, val: "PREMIUM" },
        { dname: "Advanced", checked: false, val: "ADVANCED" },
    ]);
    // 필터 이벤트
    function filterOpen(e) {
        // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
        var dtDiv = document.querySelector("#mcheck_term__date");
        var isDtMobile = (dtDiv.clientHeight <= 0) && (dtDiv.clientWidth <= 0) ? true : false;
        if (isDtMobile) {
            CUTIL.jsopen_Popup(e);
        }
        else {
            const targetElement = e.target;
            const filterBox = targetElement.closest(".filter");
            if (CUTIL.isnull(filterBox))
                return;
            //  clog(flieterLayer);
            // clog("filterOpen : " + filterBox.className);
            if (filterBox.classList.contains("open")) {
                filterBox.classList.remove("open"); // open
                setSpgItem(spgItem.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
                setFilterList(filterList.map((filter) => (filter.dname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
            }
            else {
                filterBox.classList.add("open"); // close
                setSearchFilterList([]);
                setSpg([]);
            }
            const changeBoxElements = document.querySelectorAll(".search-small");
            changeBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("open");
                setSearchText("");
                setSearchData({
                    "searchField": null,
                    "searchText": null,
                });
            });
        }
    }
    //검색 이벤트
    function searchOpen(e) {
        // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
        var dtDiv = document.querySelector("#mcheck_term__date");
        var isDtMobile = (dtDiv.clientHeight <= 0) && (dtDiv.clientWidth <= 0) ? true : false;
        if (isDtMobile) {
            CUTIL.jsopen_Popup(e);
        }
        else {
            const targetElement = e.target;
            const searchBox = targetElement.closest(".search-small");
            if (CUTIL.isnull(searchBox))
                return;
            if (searchBox.classList.contains("open")) {
                searchBox.classList.remove("open"); // close
                setSearchText("");
                setSearchData({
                    "searchField": null,
                    "searchText": null,
                });
            }
            else {
                searchBox.classList.add("open"); //
            }
            const changeBoxElements = document.querySelectorAll(".filter");
            changeBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("open");
                setSpgItem(spgItem.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
                setFilterList(filterList.map((filter) => (filter.dname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
            });
        }
    }
    ;
    function handleClickSpgFilter(filterVal) {
        if (filterVal === "전체") {
            setSpgItem(spgItem.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
        }
        else { // 개별
            setSpgItem(spgItem.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: false }) : (filter.fname === filterVal) ? Object.assign(Object.assign({}, filter), { checked: !filter.checked }) : filter));
        }
    }
    function handleClickSearchFilter(filterVal) {
        if (filterVal === "전체") {
            setFilterList(filterList.map((filter) => (filter.dname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
        }
        else { // 개별
            setFilterList(filterList.map((filter) => (filter.dname === "전체") ? Object.assign(Object.assign({}, filter), { checked: false }) : (filter.dname === filterVal) ? Object.assign(Object.assign({}, filter), { checked: !filter.checked }) : filter));
        }
    }
    function doSearchCount() {
        setSearchCount({
            "startDate": startDate,
            "endDate": endDate,
        });
    }
    function onClickSearchFilter(e) {
        // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
        var dtDiv = document.querySelector("#mcheck_term__date");
        var isDtMobile = (dtDiv.clientHeight <= 0) && (dtDiv.clientWidth <= 0) ? true : false;
        if (startDate == null) {
            alert("시작일자를 입력하세요");
        }
        else if (endDate == null) {
            alert("종료일자를 입력하세요");
        }
        else {
            handleCurPage(0);
            setSubZone(subZoneSel);
            setRoom(roomSel);
            // search시 필터 적용
            setSpg(spgItem.filter((filter) => filter.checked));
            setSearchFilterList(filterList.filter((filter) => filter.checked));
            doSearchCount();
            if (isDtMobile) {
                CUTIL.jsclose_Popup("pop-filter");
                handleCurPage(0);
                setSearchText("");
                setSearchField(searchFieldList[0]);
                setSearchData({
                    searchField: "",
                    searchText: ""
                });
            }
        }
    }
    function resetSearchParams() {
        handleCurPage(0);
        document.getElementById("subZone").click();
        document.getElementById("subZoneAll").click();
        document.getElementById("room").click();
        document.getElementById("roomAll").click();
        document.getElementById("date").click();
        document.getElementById("date_4").click();
        document.getElementById("subZoneM").click();
        document.getElementById("subZoneAllM").click();
        document.getElementById("roomM").click();
        document.getElementById("roomAllM").click();
        document.getElementById("dateM").click();
        document.getElementById("dateM_4").click();
        setSubZoneSel("");
        setSubZone("");
        setRoomSel("");
        setRoom("");
        ;
        setSearchText("");
        setSearchField(searchFieldList[0]);
        setSearchData({
            searchField: "",
            searchText: ""
        });
        setSearchFilterList([]);
        setSpg([]);
        setSpgItem(spgItem.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
        setFilterList(filterList.map((filter) => (filter.dname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
    }
    function onClickGoSearch(e) {
        // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
        var dtDiv = document.querySelector("#mcheck_term__date");
        var isDtMobile = (dtDiv.clientHeight <= 0) && (dtDiv.clientWidth <= 0) ? true : false;
        handleCurPage(0);
        setSearchData({
            searchField: searchField,
            searchText: searchText
        });
        if (isDtMobile) {
            CUTIL.jsclose_Popup("pop-search-small");
            handleCurPage(0);
            document.getElementById("subZone").click();
            document.getElementById("subZoneAll").click();
            document.getElementById("room").click();
            document.getElementById("roomAll").click();
            document.getElementById("date").click();
            document.getElementById("date_4").click();
            document.getElementById("subZoneM").click();
            document.getElementById("subZoneAllM").click();
            document.getElementById("roomM").click();
            document.getElementById("roomAllM").click();
            document.getElementById("dateM").click();
            document.getElementById("dateM_4").click();
            setSubZoneSel("");
            setSubZone("");
            setRoomSel("");
            setRoom("");
            ;
            setSearchFilterList([]);
            setSpg([]);
            setSpgItem(spgItem.map((filter) => (filter.fname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
            setFilterList(filterList.map((filter) => (filter.dname === "전체") ? Object.assign(Object.assign({}, filter), { checked: true }) : Object.assign(Object.assign({}, filter), { checked: false })));
        }
    }
    //MobileFliter
    useEffect(() => {
        setParentPopWin("pop-filter", React.createElement(MobileFilter, { curTab: curTab, onClickSubZoneSelect: onClickSubZoneSelect, subZoneItem: subZoneItem, setRoomSel: setRoomSel, roomItem: roomItem, dateTermList: dateTermList, handleDayPop: handleDayPop, dateSel: dateSel, langs: langs, startDate: startDate, setStartDate: setStartDate, endDate: endDate, setEndDate: setEndDate, mintStartDate: mintStartDate, maxEndDate: maxEndDate, spgItem: spgItem, filterList: filterList, handleClickSpgFilter: handleClickSpgFilter, handleClickSearchFilter: handleClickSearchFilter, onClickSearchFilter: onClickSearchFilter }));
    });
    //MobileSearch
    useEffect(() => {
        setParentPopWin("pop-search-small", React.createElement(MobileSEarch, { t: t, searchFieldList: searchFieldList, setSearchField: setSearchField, searchText: searchText, setSearchText: setSearchText, onClickGoSearch: onClickGoSearch }));
    });
    function handleZipDownload(e) {
        //const [zipList, setZipList] = useState([]);
        let zipList = [];
        let zips = new JSZip();
        let zipCnt = 0;
        const zipFileName = "진단점검리포트.zip";
        checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
            //await sleep(5000);
            yield getSecondFileUrl(zipList, list).then((val) => {
                //clog("getSecondFileUrl : " + JSON.stringify(val));
                if (val.codeNum === 200) {
                    //setZipList([...zipList.concat({"fileName" : `${list.itemReportDtoOut.itemName}_진단점검리포트.PDF`, "fileLink" : data.body.fileLink})]);
                    zipList = zipList.concat({ "fileName": `${list.itemReportDtoOut.itemName + "_" + idx}_진단점검리포트.PDF`, "fileLink": val.body.fileLink });
                }
                return { "codeNum": val.codeNum, "fileName": `${list.itemReportDtoOut.itemName + "_" + idx}_진단점검리포트.PDF`, "fileLink": val.body.fileLink };
            }).then((val) => {
                if (val.codeNum === 200) {
                    axios({
                        method: "GET",
                        url: val.fileLink,
                        responseType: "blob",
                    }).then((resp) => {
                        zips.file(val.fileName, resp.data);
                        zipCnt++;
                        return zipCnt;
                    }).then((zipCnt) => {
                        if (zipCnt === checkItem.length) {
                            //FILEUTILS.saveToFile_Chrome(fileName, response.data);
                            zips.generateAsync({ type: "blob" }).then(function (blob) {
                                FILEUTILS.saveToFile_Chrome(zipFileName, blob);
                            });
                        }
                    });
                }
            });
        }));
    }
    //const [zipList, setZipList] = useState([]);
    function getSecondFileUrl(zipList, list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/report/${list.reportId}`,
                "appQuery": {},
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    //result page
    function getResultBtn(e, list) {
        setParentCurHistoryData(list.assessmentId);
        setParentCurHistoryInfo(list);
        setResultOpen(true);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { className: `box list ${(isLoadingBox) ? "loading__box" : ""} ` },
            React.createElement("div", { className: `box__body ${(pageInfo.totalElements <= 0) ? "nodata" : ""}` },
                React.createElement("section", { className: "swiper-section", style: { "cursor": "pointer" } },
                    React.createElement("div", { className: "swiper-container mySwiper" },
                        React.createElement("div", { className: "swiper-wrapper" }, (tabItem) && tabItem.filter((tab, idx) => (idx >= curPos) && ((idx < tabItem.length))).map((tab) => (React.createElement("div", { ref: tabRef, key: tab.zoneId, "data-value": tab.zoneId, className: `swiper-slide tab ${(curTab.zoneId === tab.zoneId) ? "on" : ""}`, "data-tab": tab.zoneId, onClick: (e) => onClickTab(tab) },
                            React.createElement("p", null, tab.company.companyName + " " + tab.zoneName)))))),
                    (tabItem.length >= 5) &&
                        React.createElement("div", { className: "swiper-navigation" },
                            (curPos > 0) ?
                                React.createElement("div", { className: "swiper-button-prev", onClick: (e) => prev(curPos) })
                                :
                                    React.createElement("div", { className: "swiper-button-prev  swiper-button-disabled", "aria-disabled": true }),
                            ((curPos + 3) < tabItem.length) ?
                                React.createElement("div", { className: "swiper-button-next", onClick: (e) => next(curPos) })
                                :
                                    React.createElement("div", { className: "swiper-button-next swiper-button-disabled", "aria-disabled": true }))),
                React.createElement("div", { className: "d-sm-tab" },
                    React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                        React.createElement("div", { className: "selected" },
                            React.createElement("div", { className: "selected-value" }, (curTab) && curTab.company.companyName + " " + curTab.zoneName),
                            React.createElement("div", { className: "arrow" })),
                        React.createElement("ul", null, (tabItem) && tabItem.map((tab, idx) => (React.createElement("li", { key: "tab_" + idx.toString(), className: `option tab tab ${(curTab.zoneId === tab.zoneId) ? "on" : ""} `, "data-tab": "tab-1", onClick: (e) => onClickTab(tab) }, tab.company.companyName + " " + tab.zoneName)))))),
                React.createElement("div", { id: "tab-1", className: "tabcontent current" },
                    React.createElement("div", { className: "tabcontent__top" },
                        React.createElement("div", { className: "search" },
                            (curTab) &&
                                React.createElement(SubZoneSearch, { setSubZoneItem: setSubZoneItem, curTab: curTab, onClickSubZoneSelect: onClickSubZoneSelect, subZoneItem: subZoneItem, setRoomSel: setRoomSel, roomItem: roomItem, dateTermList: dateTermList, handleDayPop: handleDayPop, langs: langs, startDate: startDate, endDate: endDate, setStartDate: setStartDate, setEndDate: setEndDate, dateSel: dateSel }),
                            React.createElement("div", { className: "btn__wrap" },
                                React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickSearchFilter(e) },
                                    React.createElement("span", null, t("LABEL.조회"))))),
                        React.createElement("div", { className: "filter js-open-m", "data-pop": "pop-filter" },
                            React.createElement("p", { className: "title ", "data-pop": "pop-filter", onClick: (e) => filterOpen(e) },
                                React.createElement("span", { "data-pop": "pop-filter" }, "Filter"),
                                React.createElement("button", { type: "button", className: "btn btn-close" },
                                    React.createElement("span", { className: "hide" }, "filter \uB2EB\uAE30")),
                                React.createElement("span", { className: "info" }, "* \uCC3D\uC744 \uB2EB\uC73C\uBA74 Filter\uB294 \uCD08\uAE30\uD654 \uB429\uB2C8\uB2E4.")),
                            React.createElement("div", { className: "filter__select" },
                                React.createElement("div", { className: "filter__type" },
                                    React.createElement("p", { className: "tit" }, t("LABEL.기기유형")),
                                    React.createElement("ul", { className: "type__cont" }, (spgItem) && spgItem.map((filter, idx) => (React.createElement("li", { key: "spg_" + idx.toString(), className: (filter.checked) ? "on" : "", onClick: (e) => handleClickSpgFilter(filter.fname) },
                                        React.createElement("a", { href: "#" }, filter.fname)))))),
                                React.createElement("div", { className: "filter__type" },
                                    React.createElement("p", { className: "tit" }, t("FIELD.점검단계")),
                                    React.createElement("ul", { className: "type__cont" }, filterList.map((filter, idx) => (React.createElement("li", { key: "chk_" + idx.toString(), className: (filter.checked) ? "on" : "", "data-value": filter.dname, onClick: (e) => handleClickSearchFilter(filter.dname) },
                                        React.createElement("a", { href: "#" }, filter.dname)))))))),
                        React.createElement("div", { className: "search-small js-open-m", "data-pop": "pop-search-small" },
                            React.createElement("p", { className: "title", "data-pop": "pop-search-small", onClick: (e) => searchOpen(e) },
                                React.createElement("span", { "data-pop": "pop-search-small" }, t("LABEL.검색")),
                                React.createElement("button", { type: "button", className: "btn btn-close" },
                                    React.createElement("span", { className: "hide" },
                                        t("LABEL.검색"),
                                        " \uB2EB\uAE30"))),
                            React.createElement("div", { className: "search__cont" },
                                React.createElement("div", { className: "searcharea" },
                                    React.createElement("div", { className: "searchinput" },
                                        React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                            React.createElement("div", { className: "selected" },
                                                React.createElement("div", { className: "selected-value" }, searchFieldList[0].sfDisp),
                                                React.createElement("div", { className: "arrow" })),
                                            React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf), onClick: (e) => setSearchField(sf) }, sf.sfDisp))))),
                                        React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, onChange: (e) => setSearchText(e.target.value) })),
                                    React.createElement("button", { type: "button", className: "btn btn-delete" },
                                        React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30")),
                                    React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickGoSearch(e) },
                                        React.createElement("span", null, t("LABEL.조회")))))),
                        ((spgItem.filter((filter) => (filter.checked) && (filter.fname !== "전체")).length > 0) || (filterList.filter((filter) => (filter.checked) && (filter.dname !== "전체")).length > 0) || (searchText.length > 0))
                            ? React.createElement("button", { type: "button", className: "btn-renew", onClick: resetSearchParams },
                                React.createElement("span", null, t("LABEL.필터초기화")))
                            : React.createElement("button", { type: "button", className: "btn-renew", disabled: true },
                                React.createElement("span", null, t("LABEL.필터초기화")))),
                    React.createElement("div", { className: "tbl__top", id: "mcheck_term__date" }, (pageInfo.totalElements > 0) &&
                        React.createElement("div", { className: "right" }, (checkItem.length > 0) ?
                            React.createElement("button", { type: "button", className: "btn-basic", onClick: (e) => handleZipDownload(e) },
                                React.createElement("span", null, "Report Download"))
                            :
                                // 체크 없을 시 disabled 처리
                                React.createElement("button", { type: "button", className: "btn-basic ", disabled: true },
                                    React.createElement("span", null, "Report Download")))),
                    (pageInfo.totalElements <= 0) &&
                        React.createElement("p", { className: "nodata__txt" }, t("MESSAGE.데이터를찾을수없습니다")),
                    (curTab) &&
                        React.createElement(ItemCheckHistoryView, { curTab: curTab, mobileRef: mobileRef, isMobile: isMobile, setParentPopWin: setParentPopWin, pageInfo: pageInfo, setPageInfo: setPageInfo, getResultBtn: getResultBtn, checkItem: checkItem, setCheckItem: setCheckItem, subZone: subZone, room: room, spg: spg, searchFilter: searchFilterList, searchTextField: searchData, handleCurPage: handleCurPage, searchCount: searchCount }),
                    (pageInfo) && React.createElement(EhpPagination, { componentName: "HISTYORY", pageInfo: pageInfo, handleFunc: handleCurPage }))))));
}
export default ItemCheckHistory;
function SubZoneSearch(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const { setSubZoneItem, curTab, onClickSubZoneSelect, subZoneItem, setRoomSel, roomItem, dateTermList, handleDayPop, langs, startDate, endDate, setStartDate, setEndDate, dateSel, } = props;
    // tab APi
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/${curTab.zoneId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: curTab.zoneId
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSubZoneItem(data.body);
            }
            else {
                alert(data.errorList.map((err) => (err.msg)));
            }
        }
    }, [data]);
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: "form__input" },
            React.createElement("li", null,
                React.createElement("label", { htmlFor: "company" }, t("FIELD.상세사업장")),
                React.createElement("div", { className: "input__area" },
                    React.createElement("div", { id: "subZone", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                        React.createElement("div", { className: "selected" },
                            React.createElement("div", { className: "selected-value" }, t("FIELD.전체")),
                            React.createElement("div", { className: "arrow" })),
                        React.createElement("ul", null,
                            React.createElement("li", { id: "subZoneAll", className: "option", onClick: (e) => onClickSubZoneSelect(e) }, t("FIELD.전체")),
                            (subZoneItem) && subZoneItem.map((data) => (React.createElement("li", { key: data.subZoneId, className: "option", onClick: (e) => onClickSubZoneSelect(data.subZoneId) }, data.subZoneName))))))),
            React.createElement("li", null,
                React.createElement("label", { htmlFor: "site" }, t("LABEL.전기실")),
                React.createElement("div", { className: "input__area" },
                    React.createElement("div", { id: "room", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                        React.createElement("div", { className: "selected" },
                            React.createElement("div", { className: "selected-value" }, t("FIELD.전체")),
                            React.createElement("div", { className: "arrow" })),
                        React.createElement("ul", null,
                            React.createElement("li", { id: "roomAll", className: "option", onClick: (e) => setRoomSel("") }, t("FIELD.전체")),
                            (roomItem) && roomItem.map((data) => (React.createElement("li", { key: data.roomId, className: "option", onClick: (e) => setRoomSel(data.roomId) }, data.roomName))))))),
            React.createElement("li", null,
                React.createElement("label", { htmlFor: "term" }, t("LABEL.조회기간")),
                React.createElement("div", { className: "input__area" },
                    React.createElement("div", { className: "searchterm" },
                        React.createElement("div", { id: "date", className: "select term__month", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, dateTermList[0].dtDisp),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", null, dateTermList.map((dt, idx) => (React.createElement("li", { id: "date_" + dt.id, key: `dt_${idx.toString()}`, className: "option", onClick: (e) => handleDayPop(dt) }, dt.dtDisp))))),
                        React.createElement("div", { className: "term__date" },
                            React.createElement(DatePicker, { id: "dp655863510467", 
                                // className="calendar w91"
                                locale: (langs === CONST.STR_LANG_CHA) ? zhCN : (langs === CONST.STR_LANG_ENG) ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: startDate, maxDate: endDate, 
                                // minDate={mintStartDate}
                                onChange: (date) => setStartDate(date), 
                                // onFocus={(e) => e.target.readOnly = (isMobile) && true} // 모바일 키보드 제거
                                // withPortal={(isMobile) && true}
                                onFocus: (e) => e.target.readOnly = true, readOnly: (dateSel != 0) ? true : false }),
                            React.createElement("span", { className: "centerline" }, "~"),
                            React.createElement(DatePicker
                            // className="calendar w91"
                            , { 
                                // className="calendar w91"
                                id: "dp1655863510468", locale: (langs === CONST.STR_LANG_CHA) ? zhCN : (langs === CONST.STR_LANG_ENG) ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: endDate, minDate: startDate, 
                                // maxDate={maxEndDate}
                                onChange: (date) => setEndDate(date), onFocus: (e) => e.target.readOnly = true, readOnly: (dateSel != 0) ? true : false }))))))));
}
function ItemCheckHistoryView(props) {
    //trans
    const t = useTrans();
    //recoil
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const mobileRef = props.mobileRef;
    const isMobile = props.isMobile;
    const curTab = props.curTab;
    const pageInfo = props.pageInfo;
    const setPageInfo = props.setPageInfo;
    const getResultBtn = props.getResultBtn;
    const checkItem = props.checkItem;
    const setCheckItem = props.setCheckItem;
    const handleCurPage = props.handleCurPage;
    const subZone = props.subZone;
    const room = props.room;
    const searchSpg = props.spg;
    const searchFilter = props.searchFilter;
    const searchTextField = props.searchTextField;
    const searchCount = props.searchCount;
    const setParentPopWin = props.setParentPopWin;
    let appPath = curTab.zoneId;
    // device List API
    appPath = appPath + '&page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (!CUTIL.isnull(subZone) && (subZone.length > 0)) {
        appPath = appPath + '&subZoneId=' + subZone;
        // clog("필터 상세사업장 : " + appPath);
    }
    if (!CUTIL.isnull(room) && (room.length > 0)) {
        appPath = appPath + '&roomId=' + room;
        // clog("필터 사이트 : " + appPath);
    }
    if ((!CUTIL.isnull(searchCount.startDate)) && (!CUTIL.isnull(searchCount.startDate))) {
        appPath = appPath
            + `&startDate=${CUTIL.date2formedstr(searchCount.startDate, "yyyyMMdd")}`
            + `&endDate=${CUTIL.date2formedstr(searchCount.endDate, "yyyyMMdd")}`;
    }
    //text검색
    if (searchTextField.searchField) {
        if (searchTextField.searchField.sfVal.length > 0) {
            //appPath = appPath + `&searchKind=${searchData.searchField.sfVal}&searchLike=${searchData.searchText}`;
            appPath = appPath + `&${searchTextField.searchField.sfVal}=` + searchTextField.searchText;
        }
    }
    else {
        let spgFilter = "";
        searchSpg.filter((filter) => (filter.checked === true) /* && (filter.fname !== "전체") */).map((filter, idx) => {
            if (idx > 0)
                spgFilter = spgFilter + ",";
            spgFilter = spgFilter + filter.val;
        });
        if (!CUTIL.isnull(spgFilter) && spgFilter.length > 0 /* && spgFilter != "전체" */) {
            appPath = appPath + "&spgList=" + spgFilter;
        }
        let strFilter = "";
        searchFilter.filter((filter) => (filter.checked === true) /*  && (filter.dname !== "전체") */).map((filter, idx) => {
            if (idx > 0)
                strFilter = strFilter + ",";
            strFilter = strFilter + filter.val;
        });
        if (!CUTIL.isnull(strFilter) && strFilter.length > 0 /*  && strFilter != "전체" */) {
            appPath = appPath + "&stepList=" + strFilter;
        }
    }
    //table
    const [historyData, setHistoryData] = useState([]);
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/assessments?page=${pageInfo.number}&size${pageInfo.size}&zoneId=${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath
    });
    useEffect(() => {
        if (data) {
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
            if (ERR_URL.length > 0) {
                setRecoilIsLoadingBox(false);
                navigate(ERR_URL);
            }
            if (data.codeNum == CONST.API_200) {
                setHistoryData(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false })); //5, 10
            }
            else {
                alert(data.errorList.map((err) => (err.msg)));
            }
        }
    }, [data]);
    //chcek
    const checkedAll = useCallback((checked) => {
        if (checked) {
            const checkedArray = [];
            historyData.forEach((list) => { checkedArray.push(list); });
            setCheckItem(checkedArray);
        }
        else {
            setCheckItem([]);
        }
    }, [historyData]);
    //checkbox
    const checkedList = useCallback((checked, list) => {
        if (checked) {
            setCheckItem([...checkItem, list]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el !== list));
        }
    }, [checkItem]);
    //상세 정보
    function listView(e, list) {
        setParentPopWin("pop-list-view", React.createElement(MobileListView, { htmlHeader: React.createElement("h1", null, "\uC9C4\uB2E8\uC810\uAC80 \uB9AC\uD3EC\uD2B8 \uC0C1\uC138\uC815\uBCF4"), list: list }));
        CUTIL.jsopen_m_Popup(e);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tbl-list" },
            React.createElement("table", { summary: "\uC120\uD0DD, \uC810\uAC80\uB2E8\uACC4,\uC0AC\uC5C5\uC7A5,\uC0AC\uC774\uD2B8,\uC720\uD615,\uAE30\uAE30\uBA85,\uC81C\uC870\uBC88\uD638,\uB2F4\uB2F9\uC790,\uC810\uAC80\uC77C\uC790,\uD3C9\uAC00\uC810\uC218,Report,Memo,\uC810\uAC80 \uACB0\uACFC \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Report-List \uC785\uB2C8\uB2E4." },
                React.createElement("caption", null, "Report-List"),
                React.createElement("colgroup", null,
                    React.createElement("col", { style: {} })),
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { scope: "col", className: "d-mm-none" },
                            React.createElement("input", { type: "checkbox", id: "t_all", checked: checkItem.length === 0 ? false : checkItem.length === historyData.length ? true : false, onChange: (e) => checkedAll(e.target.checked) }),
                            React.createElement("label", { htmlFor: "t_all" },
                                React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                        React.createElement("th", { scope: "col" },
                            React.createElement("span", null, t("FIELD.점검단계"))),
                        React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                            React.createElement("span", null, t("FIELD.상세사업장"))),
                        React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                            React.createElement("span", null, t("FIELD.전기실"))),
                        React.createElement("th", { scope: "col", className: "txt-left d-lm-none" },
                            React.createElement("span", null, t("FIELD.기기명"))),
                        React.createElement("th", { scope: "col", className: "txt-left" },
                            React.createElement("span", null, t("FIELD.모델명"))),
                        React.createElement("th", { scope: "col", className: "txt-left d-mm-none" },
                            React.createElement("span", null, t("FIELD.시리얼번호"))),
                        React.createElement("th", { scope: "col", className: "txt-left d-mm-none" },
                            React.createElement("span", null, t("FIELD.담당자"))),
                        React.createElement("th", { scope: "col", className: "txt-left" },
                            React.createElement("span", null, t("FIELD.점검일자"))),
                        React.createElement("th", { scope: "col", className: "txt-left d-lm-none" },
                            React.createElement("span", null, t("FIELD.평가점수"))),
                        React.createElement("th", { ref: mobileRef, scope: "col", className: "d-mm-none" },
                            React.createElement("span", null, t("FIELD.Report"))),
                        React.createElement("th", { scope: "col", className: "d-lm-none" },
                            React.createElement("span", null, t("FIELD.Memo"))),
                        React.createElement("th", { scope: "col", className: "txt-left" },
                            React.createElement("span", null, t("FIELD.점검결과"))))),
                React.createElement("tbody", null, (historyData) && historyData.map((list, idx) => (React.createElement("tr", { key: "check" + idx },
                    React.createElement("td", { className: "d-mm-none" },
                        React.createElement("input", { type: "checkbox", id: "t_" + idx, checked: checkItem.includes(list) ? true : false, onChange: (e) => checkedList(e.target.checked, list) }),
                        React.createElement("label", { htmlFor: "t_" + idx },
                            React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                    React.createElement("td", { className: `${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } },
                        React.createElement("span", { className: `checkstep ${(list.checkStepDto.name === "BASIC") ? "ehc-b" : (list.checkStepDto.name === "PREMIUM") ? "ehc-p" : (list.checkStepDto.name === "ADVANCED") ? "ehc-a" : ""}` }, (list.checkStepDto.name === "BASIC") ? "B" : (list.checkStepDto.name === "PREMIUM") ? "P" : (list.checkStepDto.name === "ADVANCED") ? "A" : "")),
                    React.createElement("td", { className: `txt-left d-sm-none ${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } }, list.subZoneName),
                    React.createElement("td", { className: `txt-left d-sm-none ${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } }, list.roomName),
                    React.createElement("td", { className: `txt-left d-lm-none ${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } }, list.spgDto.name),
                    React.createElement("td", { className: `txt-left ${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } }, list.itemReportDtoOut.itemName),
                    React.createElement("td", { className: `txt-left d-mm-none ${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } },
                        React.createElement("p", { className: "ellipsis" },
                            React.createElement("span", { className: "tooltip" },
                                list.itemReportDtoOut.serialNo,
                                React.createElement("span", { className: "tooltip-text" }, list.itemReportDtoOut.serialNo)))),
                    React.createElement("td", { className: `txt-left d-mm-none ${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } }, list.itemReportDtoOut.responsible),
                    React.createElement("td", { className: `txt-left  ${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } }, CUTIL.utc2time("YYYY-MM-DD", list.updatedTime)),
                    React.createElement("td", { className: `txt-left d-lm-none  ${(isMobile) ? "js-open-m" : ""}`, "data-pop": "pop-list-view", onClick: (e) => { (isMobile) ? listView(e, list) : ""; } },
                        React.createElement("p", { className: `score ${(list.alarmStatus == "WARNING_SCORE") ? "middle" : (list.alarmStatus = "SAFETY") ? "high" : ""}` }, list.totalScore)),
                    React.createElement("td", { className: `d-mm-none` }, (list.reportId == null)
                        ? React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                            React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC"))
                        : React.createElement("button", { type: "button", className: "btn btn-file", onClick: (e) => { HTTPUTIL.fileDownload_WithPdfViewer(list.itemReportDtoOut.serialNo, list.reportId, userInfo.loginInfo.token); } },
                            React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC"))),
                    React.createElement("td", { className: `d-lm-none` }, (list.totalComment == "") ?
                        React.createElement("button", { type: "button", className: "btn btn-memo", disabled: true },
                            React.createElement("span", { className: "hide" }, "\uBA54\uBAA8"))
                        : React.createElement("button", { type: "button", className: "btn btn-memo" },
                            React.createElement("span", { className: "hide" }, "\uBA54\uBAA8"))),
                    React.createElement("td", null,
                        React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => getResultBtn(e, list) },
                            React.createElement("span", null, t("FIELD.보기"))))))))))));
}
// 모바일 filter
function MobileFilter(props) {
    const t = useTrans();
    const { curTab, subZoneSle, onClickSubZoneSelect, subZoneItem, setRoomSel, roomItem, dateTermList, handleDayPop, langs, startDate, setStartDate, endDate, setEndDate, mintStartDate, maxEndDate, spgItem, filterList, handleClickSpgFilter, handleClickSearchFilter, onClickSearchFilter, dateSel, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input d-sm-block" },
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "company" }, t("FIELD.상세사업장")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "subZoneM", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, t("FIELD.전체")),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", null,
                                React.createElement("li", { id: "subZoneAllM", className: "option", onClick: (e) => onClickSubZoneSelect(e) }, t("FIELD.전체")),
                                (subZoneItem) && subZoneItem.map((data) => (React.createElement("li", { key: data.subZoneId, className: "option", onClick: (e) => onClickSubZoneSelect(data.subZoneId) }, data.subZoneName))))))),
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "site" }, t("LABEL.전기실")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "roomM", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, t("FIELD.전체")),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", null,
                                React.createElement("li", { id: "roomAllM", className: "option", onClick: (e) => setRoomSel("") }, t("FIELD.전체")),
                                (roomItem) && roomItem.map((data) => (React.createElement("li", { key: data.roomId, className: "option", onClick: (e) => setRoomSel(data.roomId) }, data.roomName))))))),
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "term" }, t("LABEL.조회기간")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { className: "searchterm" },
                            React.createElement("div", { id: "dateM", className: "select term__month", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, dateTermList[0].dtDisp),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, dateTermList.map((dt, idx) => (React.createElement("li", { id: "dateM_" + dt.id, key: `dt_${idx.toString()}`, className: "option", onClick: (e) => handleDayPop(dt) }, dt.dtDisp))))),
                            React.createElement("div", { className: "term__date" },
                                React.createElement(DatePicker
                                // id="dp655863510467"
                                , { 
                                    // id="dp655863510467"
                                    className: "calendar", locale: (langs === CONST.STR_LANG_CHA) ? zhCN : (langs === CONST.STR_LANG_ENG) ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: startDate, maxDate: endDate, minDate: mintStartDate, onChange: (date) => setStartDate(date), onFocus: (e) => e.target.readOnly = true, withPortal // 전체 적용
                                    : true, readOnly: (dateSel != 0) ? true : false }),
                                React.createElement("span", { className: "centerline" }, "~"),
                                React.createElement(DatePicker, { className: "calendar", 
                                    // id="dp1655863510468"
                                    locale: (langs === CONST.STR_LANG_CHA) ? zhCN : (langs === CONST.STR_LANG_ENG) ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: endDate, minDate: startDate, maxDate: maxEndDate, onChange: (date) => setEndDate(date), onFocus: (e) => e.target.readOnly = true, withPortal: true, readOnly: (dateSel != 0) ? true : false })))))),
            React.createElement("div", { className: "filter__select" },
                React.createElement("div", { className: "filter__type" },
                    React.createElement("p", { className: "tit" }, t("LABEL.기기유형")),
                    React.createElement("ul", { className: "type__cont" }, (spgItem) && spgItem.map((filter, idx) => (React.createElement("li", { key: "spg_" + idx.toString(), className: (filter.checked) ? "on" : "", onClick: (e) => handleClickSpgFilter(filter.fname) },
                        React.createElement("a", { href: "#" }, filter.fname)))))),
                React.createElement("div", { className: "filter__type" },
                    React.createElement("p", { className: "tit" }, t("FIELD.점검단계")),
                    React.createElement("ul", { className: "type__cont" }, filterList.map((filter, idx) => (React.createElement("li", { key: "chk_" + idx.toString(), className: (filter.checked) ? "on" : "", "data-value": filter.dname, onClick: (e) => handleClickSearchFilter(filter.dname) },
                        React.createElement("a", { href: "#" }, filter.dname)))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close" },
                React.createElement("span", null, t("LABEL.취소"))),
            React.createElement("button", { type: "button", onClick: (e) => onClickSearchFilter(e) },
                React.createElement("span", null, t("LABEL.적용"))))));
}
// 모바일 {t("LABEL.검색")}
function MobileSEarch(props) {
    const { t, searchFieldList, setSearchField, searchText, setSearchText, onClickGoSearch } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "form__input mb-0" },
                React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                    React.createElement("div", { className: "selected" },
                        React.createElement("div", { className: "selected-value" }, searchFieldList[0].sfDisp),
                        React.createElement("div", { className: "arrow" })),
                    React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf), onClick: (e) => setSearchField(sf) }, sf.sfDisp))))),
                React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, onChange: (e) => setSearchText(e.target.value) }))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close" },
                React.createElement("span", null, t("LABEL.취소"))),
            React.createElement("button", { type: "button", onClick: (e) => onClickGoSearch(e) },
                React.createElement("span", null, t("LABEL.적용"))))));
}
function MobileListView(props) {
    //trans
    const t = useTrans();
    //recoil
    //const userInfo = useRecoilValue(userInfoState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const list = props.list;
    return (React.createElement(React.Fragment, null, (list) &&
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "area__right_content workplace__info" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uB9AC\uC2A4\uD2B8 \uC0C1\uC138 \uC815\uBCF4"),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.점검단계")),
                            React.createElement("p", { className: "txt" },
                                React.createElement("img", { src: require(`/static/img/icon_${(list.checkStepDto.name) ? list.checkStepDto.name[0].toLowerCase() : "x"}.png`), style: { "width": "24px", "height": "24px" }, alt: list.checkStepDto.name }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.상세사업장")),
                            React.createElement("p", { className: "txt" }, list.subZoneName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.전기실")),
                            React.createElement("p", { className: "txt" }, list.roomName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.기기명")),
                            React.createElement("p", { className: "txt" }, list.spgDto.name)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.모델명")),
                            React.createElement("p", { className: "txt" }, list.itemReportDtoOut.itemName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.시리얼번호")),
                            React.createElement("p", { className: "txt" }, list.itemReportDtoOut.serialNo)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.담당자")),
                            React.createElement("p", { className: "txt" }, list.itemReportDtoOut.responsible)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.점검일자")),
                            React.createElement("p", { className: "txt" }, CUTIL.utc2time("YYYY-MM-DD", list.updatedTime))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.평가점수")),
                            React.createElement("p", { className: `txt ` },
                                React.createElement("span", { className: `score ${(list.alarmStatus == "WARNING_SCORE") ? "middle" : (list.alarmStatus = "SAFETY") ? "high" : ""}` }, list.totalScore))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.Report")),
                            (list.reportId) &&
                                React.createElement("ul", { className: "filelist" },
                                    React.createElement("li", null,
                                        React.createElement("span", null, "PDF"),
                                        React.createElement("button", { type: "button", className: "btn btn-filedown", onClick: (e) => { HTTPUTIL.fileDownload_EhcReport(list.itemReportDtoOut.itemName, list.reportId, userInfo.loginInfo.token); } },
                                            React.createElement("span", { className: "hide" }, "\uB2E4\uC6B4\uB85C\uB4DC"))))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.메모")),
                            React.createElement("p", { className: "txt" }, list.totalComment)))),
                React.createElement("div", { className: "btn__wrap" },
                    React.createElement("button", { type: "button", className: "js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-list-view") },
                        React.createElement("span", null, t("LABEL.확인"))))))));
}
